import { sleep } from '@/utils/date';

//یک تابع رو تا زمانی که حداقل فلانقدر ازش نگذره ریسالو نمیکنه
export const callWithMinTime = async (
  callback: (...__args: any) => Promisable<any>,
  delay: number
) => {
  // @ts-ignore
  const [{ status, value, reason }] = await Promise.allSettled([
    callback(),
    delay && sleep(delay),
  ]);

  if (status === 'fulfilled') {
    return Promise.resolve(value);
  }
  return await Promise.reject(reason);
};

// * using type-guard. https://github.com/microsoft/TypeScript/issues/45097#issuecomment-882405462
export const isDefined = <T>(value: T | undefined): value is T => {
  return value !== undefined;
};

export const extractShebaNumber = (inputString: string) => {
  // Match exactly 24 consecutive digits in the string using a regular expression
  const match = inputString.match(/\b\d{24}\b/);

  // Return the matched 24-digit number or inputString if not found
  return match ? match[0] : inputString;
};

export const getCurrentNodeOverflow = (arr: number[], pos: number) => {
  let acc = 0;
  let index = 0;
  for (let i = 0; i < arr.length; i++) {
    if (acc + arr[i] > pos) {
      break;
    }

    index++;

    acc = acc + arr[i];
  }

  return [index, pos - acc];
};

export const isValidHexColor = (color: string) => {
  const regex = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
  return regex.test(color);
};

export const debounce = (func: (...__args: any[]) => void, wait: number) => {
  let timeout: NodeJS.Timeout;
  return (...args: any[]) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

export const formatToman = (amount: number): string => {
  const toman = amount / 10000; // چون 10000 ریال = 1000 تومان

  if (toman >= 1000) {
    const million = Math.floor(toman / 1000);
    const thousand = toman % 1000;

    let result = `${million} میلیون`;
    if (thousand > 0) {
      result += ` و ${thousand} هزار`;
    }
    return result + ' تومان';
  } else {
    return `${toman} هزار تومان`;
  }
};

export const buildUrl = (options: {
  pathname: string;
  query?: TQueryParams;
}): string => {
  const { pathname, query = {} } = options;

  // 1. Convert query object to [key, value] entries
  // 2. Filter out null or undefined values
  // 3. Encode and join into 'key=value' pairs
  const queryString = Object.entries(query)
    .filter(([, value]) => value != null)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
    )
    .join('&');

  // Append only if there's at least one param
  return queryString ? `${pathname}?${queryString}` : pathname;
};
